import { Component } from '@angular/core';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { METHOD_LABEL_MAP } from '@registries/methods-services';

@Component({
  selector: 'nem-landing',
  templateUrl: './landing.comp.html',
  standalone: false
})
export class LandingComponent {
  constructor(private _authenticator: AuthenticatorService) {}

  get authenticated(): boolean {
    return this._authenticator.authStatus === 'authenticated';
  }

  openTerms() {
    window.open('/assets/terms_conditions_and_privacy.pdf', '_blank');
  }

  listOfMethodNames = Object.entries(METHOD_LABEL_MAP).map(([k, v]) => v);
}
